//https://github.com/Semantic-Org/Semantic-UI-React/issues/2558
const modalInlineStyle =  {}
/*       marginTop: '0px !important',
      marginLeft: 'auto',
      marginRight: 'auto'
    }; */

  export default modalInlineStyle;